
export const SUPPORTED_MODULES = ["planning", "structure", "elevation", "interior"];

const MODULE_GROUP = SUPPORTED_MODULES.join("|");


const MODULE_PATH_PATTERN = new RegExp(
  `^/(${MODULE_GROUP})(?:/([^/?]+))?/?$`,
  "i"
);


const PROJECT_ID_QUERY_KEYS = ["projectId", "pid", "id"];


export function extractProjectLink(rawUrl) {
  if (!rawUrl || typeof rawUrl !== "string") return null;

  const safeRawUrl = rawUrl.replace(/^\/+/, "/");

  let url;
  try {
    url = new URL(safeRawUrl, window.location.origin);
  } catch {
    return null;
  }

  // Double/triple slashes normalize karo ("//planning/PRJx" -> "/planning/PRJx")
  const pathname = url.pathname.replace(/\/+/g, "/");

  const match = pathname.match(MODULE_PATH_PATTERN);
  if (!match) return null;

  const moduleName = match[1].toLowerCase();

  // Pehle path se projectId lo ("/planning/PRJxxx"); agar wahan nahi mila,
  // to query params se try karo ("/planning?projectId=PRJxxx").
  let projectId = match[2] || "";
  if (!projectId) {
    for (const key of PROJECT_ID_QUERY_KEYS) {
      const val = url.searchParams.get(key);
      if (val) {
        projectId = val;
        break;
      }
    }
  }

  projectId = projectId.trim();
  if (!projectId) return null; // module mila par project id kahin nahi mila — incomplete link

  // Baaki useful query params (token, updatedby, version, viewMode) preserve
  // karo — sirf projectId-carrying keys hatao taaki duplicate na ho.
  const preserved = new URLSearchParams(url.search);
  PROJECT_ID_QUERY_KEYS.forEach((key) => preserved.delete(key));
  const qs = preserved.toString();

  return `/${moduleName}/${encodeURIComponent(projectId)}${qs ? `?${qs}` : ""}`;
}

/** Sirf true/false chahiye ho to ye helper use karo. */
export function isAuthenticProjectLink(rawUrl) {
  return !!extractProjectLink(rawUrl);
}
